// Data that configures the Player Possession Table
import baseColumns from '@/data/player/baseColumns';

export default {
  columns: baseColumns,
};
